import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const LookupPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => theme.space.space16};
  background: ${({ theme }) => theme.colors.tone.white};
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space8};
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export const SecureLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space4};
  padding: ${({ theme }) =>
    `${theme.space.space8 || "8px"} 0 ${theme.space.space16 || "16px"}`};
  font-size: ${({ theme }) => theme.fontSizes.fontSize12};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.tone.anthracite};
`;

export const FieldGroup = styled.div`
  margin-bottom: ${({ theme }) => theme.space.space16};
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${({ theme }) => theme.space.space4};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.tone.black};
`;

export const HelperText = styled.div`
  margin-top: ${({ theme }) => theme.space.space4};
  font-size: ${({ theme }) => theme.fontSizes.fontSize12};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.tone.anthracite};
`;

export const SecurityNote = styled.div`
  margin-top: ${({ theme }) => theme.space.space8};
  font-size: ${({ theme }) => theme.fontSizes.fontSize12};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.tone.anthracite};
  text-align: center;
`;

export const StatusPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space.space8};
`;

export const UnderlineLink = styled.a`
  width: 100%;
  margin-top: ${({ theme }) => theme.space.space8};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  line-height: 20px;
  color: ${({ theme }) => theme.colors.tone.black};
  text-align: center;
  text-decoration: underline;
`;

export const SheetWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 -4px 8px 0 ${({ theme }) => theme.effects.overlay.black_10};
  border-radius: 16px 16px 0 0;
  background-color: ${({ theme }) => theme.colors.tone.white};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  animation: ${slideUp} 0.3s ease;
`;

export const SheetOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => `${theme.colors.tone.black}80`};
  z-index: ${({ theme }) => theme.zIndex.drawer};
`;
